import React from "react";

// Recreated iBizztax.com logo using text + a cloud icon (CSS/SVG)
const Logo = ({ size = "lg" }) => {
  const isSm = size === "sm";
  return (
    <div className="flex flex-col items-center select-none">
      <div className={`font-bold tracking-tight ${isSm ? "text-xl" : "text-4xl"}`}>
        <span style={{ color: "#1877c9" }}>Spec</span>
        <span style={{ color: "#e8731c" }}>field</span>
      </div>
      {!isSm && (
        <div className="text-gray-900 font-bold text-sm mt-1 tracking-wide uppercase">
          Tax Services Sdn. Bhd.
        </div>
      )}
      {!isSm && (
        <div className="text-gray-400 text-xs mt-0.5 tracking-wide">
          202601016082 (1678179-W)
        </div>
      )}
    </div>
  );
};

export default Logo;
